import { UserManagement, UserManagementInviteData, UserInviteResponse } from '../../types/user';
import apiClient from '../client';

export const usersService = {
  // Get all users
  getUsers: async (): Promise<UserManagement[]> => {
    const response = await apiClient.get(`/users/`);
    const data = response.data;
    if (Array.isArray(data)) {
      return data;
    }
    if (data && Array.isArray(data.results)) {
      return data.results;
    }
    return [];
  },

  // Invite new users
  inviteUser: async (userData: UserManagementInviteData): Promise<UserInviteResponse> => {
    const response = await apiClient.post('/users/invite/', userData);
    return response.data;
  },

  // Delete user
  deleteUser: async (userId: string): Promise<void> => {
    await apiClient.delete(`/users/${userId}/remove_access/`);
  },
};
